import swal from 'sweetalert'

export default (status, statusText, messages) => {
    if (!status || messages[status] === null) return
    const message = messages[status][statusText] || messages[status] || undefined
    if (!message) {
        const swalTitle = `${status.toString()} - ${statusText || 'No status text'}`
        return swal(swalTitle, `Unmanaged status code.`, 'error')
    }

    const [ title, text, type ] = message
    return swal(title.trim(), text.trim(), type.trim())
}
